module.exports = "<highcharts-chart [Highcharts]=\"Highcharts\" [options]=\"chartOptionsdos\" style=\"height: 180px; display: block;\">\n</highcharts-chart>"